import * as React from "react";
import { IMultipleWarrantiesCost } from "./IMultipleWarrantiesCost";
import { RootState } from "../../rootReducer";
import {
    // dateFormatter,
    specialCharacterCheck,
    dropCheck,
} from "../../utils/utils";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import * as myCartActionCreators from "../MyCart/actionCreators";
import "../../../assets/sass/components/adjustCost.scss";
import { CurrencyInput } from "../../utils/numberMask";
import * as CONFIG from "../../../config.json";
import { imagePathurl } from "../../utils/utils";

interface IAdjustCostStateProps {
    hidebucks?: any;
    warrantyCost: any;
    TotalShoppingCartCost: any;
    Currency: any;
    TotalShoppingCartCostError: any;
    isCurrencyDropDown: any;
    maximum: any;
    checked?: boolean;
}
class MultipleWarrantiesAdjustCost extends React.Component<IMultipleWarrantiesCost, IAdjustCostStateProps> {
    node: any;
    constructor(props) {
        super(props);
        this.state = {
            isCurrencyDropDown: false,
            hidebucks: false,
            warrantyCost: 0.0,
            TotalShoppingCartCost: "",
            Currency: "USD",
            checked: false,
            TotalShoppingCartCostError: "",
            maximum: 9999999.99,
        };
    }
    componentDidMount() {
        const { totalAmount } = this.props;
        this.setState({
            TotalShoppingCartCost: totalAmount.toFixed(2).toString(),
            checked: false,
        });
    }
    handlePopupClose = () => {
        this.props.hidePopsUp();
        document.body.classList.remove("hideOverflow");
    };
    handleClickCost = () => {
        this.setState({
            hidebucks: !this.state.hidebucks,
        });
    };
    totalWarrantyCost = (evt) => {
        this.setState({
            TotalShoppingCartCost: evt.target.value,
        });
    };
    onBlurCheck = () => {
        this.doValidate();
    };
    onInputBoxKeyDown = (event) => {
        if (
            ["e", "E", "+"].includes(event.key) ||
            (event.key === "." && event.target.value.split(".").length > 1) ||
            (event.key === "-" && event.target.value.split("-").length > 1)
        ) {
            event.preventDefault();
        }
    };
    CurrencydropDownShow = () => {
        this.setState({
            isCurrencyDropDown: !this.state.isCurrencyDropDown,
        });
    };
    CurrencyHandler = (value) => {
        this.setState({ Currency: value });
    };
    doValidate = () => {
        const TotalShoppingCartCost = this.state.TotalShoppingCartCost
            ? parseFloat(this.state.TotalShoppingCartCost)
            : null;
        let TotalShoppingCartCostError;
        if (!TotalShoppingCartCost && TotalShoppingCartCost !== 0) {
            TotalShoppingCartCostError = "Cart Cost cannot be empty";
        } else if (isNaN(TotalShoppingCartCost) || TotalShoppingCartCost < 0) {
            TotalShoppingCartCostError = "Cart Cost cannot be less than zero";
        } else if (TotalShoppingCartCost >= 0) {
            this.setState({
                TotalShoppingCartCostError: "",
            });
        }
        if (TotalShoppingCartCostError) {
            this.setState({
                TotalShoppingCartCostError: TotalShoppingCartCostError,
            });
            return false;
        }
        return true;
    };
    validateError = () => {
        return this.doValidate();
    };
    handleCLick = () => {
        const { checked } = this.state;
        if (!checked) {
            this.setState({
                TotalShoppingCartCost: "0",
                checked: true,
            });
        } else {
            const { totalAmount } = this.props;
            this.setState({
                TotalShoppingCartCost: totalAmount.toFixed(2).toString(),
                checked: false,
            });
        }
    };
    completePayment = (e) => {
        e.preventDefault();
        const isValid = this.validateError();
        if (isValid) {
            const paymentObj = {};
            const { TotalShoppingCartCost, Currency } = this.state;
            const { myCartActions, cartId } = this.props;
            paymentObj["cartId"] = cartId;
            paymentObj["TotalShoppingCartCost"] = parseFloat(TotalShoppingCartCost);
            paymentObj["Currency"] = Currency;
            // paymentObj["warrantyCost"] = warrantyCost;
            myCartActions.beginTransaction(paymentObj);
        }
    };
    validateDecimal = (e) => {
        const t = e.target.value;
        const { maximum } = this.state;
        const intergerValue = t.split(".")[0];
        const decimalValue = t.split(".")[1];
        const maxIntergerValue = maximum.toString().split(".")[0];
        const maxDecimalValue = maximum.toString().split(".")[1];
        const prevValue = this.state[e.target.id];
        if (intergerValue.length > maxIntergerValue.length) {
            e.preventDefault();
            e.target.value = prevValue;
            return false;
        }
        if (decimalValue && decimalValue.length > maxDecimalValue.length) {
            e.preventDefault();
            e.target.value = prevValue;
            return false;
        }
        if (t.indexOf(".") >= 0) {
            e.target.value = t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3);
        }
    };

    render() {
        const { isLoading } = this.props;
        const { isCurrencyDropDown, TotalShoppingCartCostError } = this.state;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        return (
            <React.Fragment>
                <div className="gaf-adjustcost-popup-container">
                    <div className="overlay" onClick={this.handlePopupClose}>
                        <div
                            className="gaf-adjustcost-popup"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <div id="close_popup" className="close-menu" onClick={this.handlePopupClose}>
                                <img className="close-modal-icon" src={`${getimagePath}close-mobile.png`} alt="close" />
                            </div>
                            <div className="adjustcost-popup-title ml13">Continue to payment</div>

                            <div className="cost-container-sec">
                                <div className="col-sm-6 col-xs-12">
                                    <label className="label-contianer">Total cart cost</label>
                                    <div
                                        className={
                                            TotalShoppingCartCostError
                                                ? "paymenterror-boundry"
                                                : "cost-inputbox-rectangle"
                                        }
                                    >
                                        <CurrencyInput
                                            type="number"
                                            maskOptions={{ allowNegative: true }}
                                            className="gaf-inputBox total-shopping-cart-cost"
                                            value={this.state.TotalShoppingCartCost}
                                            onChange={this.totalWarrantyCost}
                                            onKeyDown={(evt) => this.onInputBoxKeyDown(evt)}
                                            onBlur={() => this.onBlurCheck()}
                                            onInput={(e) => this.validateDecimal(e)}
                                            id="TotalShoppingCartCost"
                                            max={9999999.99}
                                            onPaste={() => specialCharacterCheck}
                                            onDrop={(e) => dropCheck(e, "number")}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="errorMsg">{TotalShoppingCartCostError}</div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div className="gaf-currency-dropdown" onClick={() => this.CurrencydropDownShow()}>
                                        <img
                                            src={`${getimagePath}chevron-down.png`}
                                            className="chevron-down-thickred"
                                        />
                                        <p className="dropdown-selection" title={this.state.Currency}>
                                            {/* {this.state.Currency} */}
                                            <p> {this.state.Currency} </p>
                                        </p>
                                        {isCurrencyDropDown && (
                                            <ul className="dropdown-list">
                                                {CONFIG.CONFIG.currency.map((item, index) => {
                                                    return (
                                                        <li
                                                            key={index}
                                                            value={item}
                                                            onChange={(e) => this.CurrencyHandler(e)}
                                                        >
                                                            {item}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <label
                                    className={`gaf-dont-show-checkbox  ${
                                        this.state.checked ? "checked" : "unchecked"
                                    }`}
                                >
                                    <input
                                        checked={this.state.checked}
                                        type="checkbox"
                                        id="adjust-admin-cost"
                                        name="adjust-admin-cost"
                                        className="hide-checkbox"
                                        onClick={this.handleCLick}
                                    />
                                </label>
                                <label className="dontshow" htmlFor="adjust-admin-cost">
                                    Apply zero fee override
                                </label>
                            </div>
                            <div className="text-center">
                                <button
                                    disabled={isLoading}
                                    className="complete-payment-btn"
                                    onClick={this.completePayment}
                                >
                                    COMPLETE PAYMENT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export function mapStateToProps(state: RootState) {
    return {
        totalAmount: state.myCartInfo.totalAmount,
        cartId: state.myCartInfo.cartId,
        isLoading: state.myCartInfo.isLoading,
        beginTxData: state.myCartInfo.beginTxData,
    };
}
/**
 * @function mapDispatchToProps
 * @param dispatch
 * @description :This function will dispatch
 * action following.
 */
export function mapDispatchToProps(dispatch: Dispatch) {
    return {
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MultipleWarrantiesAdjustCost);
